import { Context, Middleware } from '@nuxt/types'
import { COOKIE_MPS_PHONE_KEY, COOKIE_MPS_PHONE_MAX_AGE_SECONDS, COOKIE_PATH } from '~/shared/const'

/**
 * Сохраняет телефон пользователя (mps_user_phone) из URL в cookie для страниц /digital-lecture.
 * Просмотр лекции фиксируется по этому телефону, если пользователь не авторизован.
 */
const digitalLecturePhone: Middleware = ({ route, $cookies }: Context) => {
  if (!route.path.startsWith('/digital-lecture')) {
    return
  }

  const phone = route.query.mps_user_phone
  if (phone) {
    $cookies.set(COOKIE_MPS_PHONE_KEY, String(phone), {
      path: COOKIE_PATH,
      maxAge: COOKIE_MPS_PHONE_MAX_AGE_SECONDS
    })
  }
}

export default digitalLecturePhone
